import { meta } from '../../../../constants';
import type { DemoSourceType } from '../types';
import type { LinkedinSourceValue } from './types';

const extraLinkedinSources: DemoSourceType<LinkedinSourceValue> = {
  'linkedin-squarespace': {
    label: 'LinkedIn: squarespace',
    source: {
      platform: 'linkedin',
      showReposts: true,
      connectionType: 'linkedinSource',
      id: 'linkedinSquarespace',
      name: 'LinkedIn',
      status: 'success',
      sourcePID: '40fc88eb-9fdc-43a7-8578-1529e37d82bb',
      source: 'https://www.linkedin.com/company/squarespace/'
    }
  },
  'linkedin-williamhgates': {
    label: 'LinkedIn: williamhgates',
    source: {
      platform: 'linkedin',
      showReposts: true,
      connectionType: 'linkedinSource',
      id: 'linkedinWilliamhgates',
      name: 'LinkedIn',
      status: 'success',
      sourcePID: 'ddcb123a-1f61-4bfd-9fec-1aaa1a0e5a79',
      source: 'https://www.linkedin.com/in/williamhgates/'
    }
  }
};

export const previewLinkedinSources: DemoSourceType<LinkedinSourceValue> = {
  'linkedin-microsoft': {
    label: 'LinkedIn: microsoft',
    source: {
      platform: 'linkedin',
      showReposts: true,
      connectionType: 'linkedinSource',
      id: 'linkedinMicrosoft',
      name: 'LinkedIn',
      status: 'success',
      sourcePID: 'd34036ff-89d7-423c-a69b-c4265dabd25a',
      source: 'https://linkedin.com/company/microsoft'
    }
  },
  'linkedin-elfsight-affiliate-program': {
    label: 'LinkedIn: elfsight-affiliate-program',
    source: {
      platform: 'linkedin',
      showReposts: true,
      connectionType: 'linkedinSource',
      id: 'linkedinElfsightAffiliateProgram',
      name: 'LinkedIn',
      status: 'success',
      sourcePID: 'a5eb12b6-ef5e-4731-9bf4-cffdcb685b61',
      source: 'https://www.linkedin.com/showcase/elfsight-affiliate-program'
    }
  },
  ...(meta.alias === 'linkedin-feed' ? extraLinkedinSources : {})
};
